const createArrow = () => {

    const postLinks = document.querySelectorAll('a.fndry-post__think-tank-title__link');

    postLinks.forEach((link) => {
        const svgNS = "http://www.w3.org/2000/svg"; // SVG namespace

        const svg = document.createElementNS(svgNS, "svg");
        svg.setAttribute("class", "svg-inline--fa fa-arrow-right-long");
        svg.setAttribute("aria-hidden", "true");
        svg.setAttribute("focusable", "false");
        svg.setAttribute("data-prefix", "fasr");
        svg.setAttribute("data-icon", "arrow-right-long");
        svg.setAttribute("role", "img");
        svg.setAttribute("xmlns", svgNS);
        svg.setAttribute("viewBox", "0 0 512 512");

        const path = document.createElementNS(svgNS, "path");
        path.setAttribute("fill", "currentColor");
        path.setAttribute(
            "d",
            "M495 273l17-17-17-17L359 103l-17-17L308.1 120l17 17 95 95L24 232 0 232l0 48 24 0 396.1 0-95 95-17 17 33.9 33.9 17-17L495 273z"
        );

        svg.appendChild(path);


        link.appendChild(svg);
    })


}

export default createArrow;